
import React, { useEffect, useState } from "react";
import ReusableTable from "../../../components/common/table";
import { Button, Popconfirm, Space } from "antd";
import { ReactComponent as AddSvg } from "../../../assets/images/add.svg";
import FilterComponent from "../../../components/common/filter";
import { useNavigate } from "react-router";
import ConfirmModal from "../../../components/common/alert-popup";
import { ReactComponent as ViewSvg } from "../../../assets/images/action/view.svg";
import { ReactComponent as DeleteSvg } from "../../../assets/images/action/delete.svg";
import { ReactComponent as EditSvg } from "../../../assets/images/action/edit.svg";
import { ReactComponent as DisableSvg } from "../../../assets/images/action/Shield Cross.svg";
import CommonFilter from "../../../components/common/filter";
import { deleteAdvertisement, listAdvertisements, updateAdvertisement } from "../../../redux/reducer/AdvertisementSlice";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import trimSearchValue, { useDebounce } from "../../../customHooks";
import { useSearchParams } from "react-router-dom";


const Advertising = () => {
  const [filteredData, setFilteredData] = useState(null);
  const navigate = useNavigate();
  const [modalConfig, setModalConfig] = useState({
    open: false,
    actionType: "",
  });
  const dispatch = useDispatch()
  const [deleteId, setDeleteId] = useState(null);
  const [disableId, setDisableId] = useState(null);
  const [disableStatus, setDisableStatus] = useState(null)
  const [refereshData, setRefereshData] = useState(false);
  const {listAds, listAdsCount, listAdsLoading} = useSelector((prev) => prev?.advertisement)

  // set page refersh 
  const [searchParams, setSearchParams] = useSearchParams();
  // Convert URLSearchParams to usable object
const getInitialParams = () => {
  const page = parseInt(searchParams.get("page")) || 1;
  const size = parseInt(searchParams.get("size")) || 10;
  const search_key = searchParams.get("search_key") || "all";
  const search_value = searchParams.get("search_value") || "";
  const status = searchParams.get("status");
  const position = searchParams.get("position");

  return {
    page,
    size,
    search_key,
    search_value,
    status: status !== null ? Number(status) : undefined,
    position: position !== null ? Number(position) : undefined,
  };
};

const [tableParams, setTableParams] = useState(getInitialParams());

useEffect(() => {
  const params = {
    page: tableParams.page,
    size: tableParams.size,
    search_key: tableParams.search_key,
    search_value: tableParams.search_value,
  };

  if (tableParams.status !== undefined) params.status = tableParams.status;
  if (tableParams.position !== undefined) params.position = tableParams.position;

  setSearchParams(params);
}, [tableParams, setSearchParams]);

  // set page refersh end


  // const [tableParams, setTableParams] = useState({
  //   page: 1,
  //   size: 10,
  //   search_value: "",
  //   search_key: "all",
  //   status: undefined,
  //   position: undefined,
  // });

  // const paginationConfig = {
  //   pageSizeOptions: ["10", "20", "50"],
  //   showSizeChanger: true,
  //   showQuickJumper: true,
  //   total: "",
  // };

 

// pagination
  const [currentPage, setCurrentPage] = useState(1);
  // const [tableParams, setTableParams] = useState({
  //   page: 1,
  //   size: 10,
  //   search_value: "",
  //   search_key: "all",
  //   status: undefined,
  //   position: undefined,
  // });

  const paginationConfig = {
    pageSizeOptions: ["10", "20", "50"], 
    showSizeChanger: true, 
    showQuickJumper: true, 
    total: listAdsCount || 1, 
    current: tableParams.page, 
    pageSize: tableParams.size, 
    onChange: (page, pageSize) => {
      setCurrentPage(page); 
      setTableParams((prev) => ({ ...prev, page, size: pageSize }));
    },
  };
  
  const handleTableChange = (pagination) => {
    setTableParams((prev) => ({
      ...prev,
      page: pagination.current,
      size: pagination.pageSize,
    }));
  };

  // pagination end

  // const debouncedSearchValue = useDebounce(tableParams.search_value, 500);

  const debouncedSearchValue = useDebounce(tableParams.search_value, 500);
  


  useEffect(()=> {
    dispatch(listAdvertisements(trimSearchValue(tableParams)))
  },[dispatch, refereshData,
    tableParams.page, tableParams.size,
    debouncedSearchValue,
    tableParams.status,
    tableParams.position,
  ])

  const handleDateFilter = (dates, dateStrings) => {
    if (!dates) {
      setFilteredData(dataSource);
      return;
    }
    const [startDate, endDate] = dateStrings;
    const filtered = dataSource.filter((item) => {
      const itemDate = new Date(item.date_added);
      return itemDate >= new Date(startDate) && itemDate <= new Date(endDate);
    });
    setFilteredData(filtered);
  };
  const showModal = (actionType) => {
    setModalConfig({ open: true, actionType });
  };

  const closeModal = () => {
    setModalConfig({ open: false, actionType: "" });
  };

  const handleSearch = (searchText) => {
    const filtered = dataSource.filter((item) =>
      item.tenant_name.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: (text, record, index) => (tableParams.page - 1) * tableParams.size + index + 1, 
    },
    {
      title: "Banner Title",
      dataIndex: "title_en",
      key: "banner_media",
      type: "search",
    },
   
    {
      title: "Banner Image",
      dataIndex: "url_en",
      key: "banner_media",
      render: (url_en) => (
        <div>
          {url_en ? (
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}/${url_en}`}
              alt="Banner"
              style={{ width: "100px", height: "50px", objectFit:"contain", borderRadius: "8px" }}
            />
          ) : (
            "No Image"
          )}
        </div>
      ),
    },

    
    {
      title: "Banner Position",
      dataIndex: "position",
      key: "banner_position",
      type: "select",
      width: "200px",
      render: (position) => (position === 1 ? "Top" : "Bottom"),
      options: [
        { label: "Top", value: 1 },
        { label: "Bottom", value: 0 },
       ],
    },
    {
      title: "Created By",
      dataIndex: "created_by",
      key: "edit_by",
      // type: "search",
      width: "140px",
      render: (created_by, record) => (created_by === 1 ? "Admin" : record.auth_name_en
      ),
    },
    {
      title: "Date Added",
      dataIndex: "created_at",
      key: "date_added",
      // type: "date",
      // render: (date) => dayjs(date).format("MM-DD-YYYY"),
      render: (date) => {
        const dateObject = new Date(date);
        const day = String(dateObject.getUTCDate()).padStart(2, '0');       
        const month = String(dateObject.getUTCMonth() + 1).padStart(2, '0'); 
        const year = dateObject.getUTCFullYear();                          
        return `${month}-${day}-${year}`;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      type: "select",
      width: "90px",
      render: (status) => (status === 1 ? <p className="active-status">Active</p> : <p className="inactive-status">Inactive</p>), // Check if status is 1
      options: [
        { label: "Active", value: 1 },
        { label: "Inactive", value: 0 },
       ],
    },
  ];

  const dataSource = [
    {
      key: "1",
      sr_no: "1",
      banner_media: "Acme Corp",
      banner_position: "Top",
      status: "Active",
      date_added: "2024-02-15",
    },
    {
      key: "2",
      sr_no: "2",
      banner_media: "Tech Solutions",
      banner_position: "Center",
      status: "Inactive",
      date_added: "2023-05-10",
    },
    {
      key: "3",
      sr_no: "3",
      banner_media: "Innovate Inc.",
      banner_position: "Center",
      status: "Active",
      date_added: "2024-03-01",
    },
  ];


  const handleDeleteClick = (id) => {
    setDeleteId(id);
    showModal("delete"); // Open the modal
  };

  const handleDisableClick = (id, status) => {
    if(status === 1){
      showModal("disable", id, status)
    }else if(status === 0){
      showModal("enable", id, status)
    } else{
      
    }    
    setDisableStatus(status)
    setDisableId(id);
  };

  const handleConfirm = async () => {
    try {
      if (modalConfig.actionType === "delete" && deleteId) {
        await dispatch(deleteAdvertisement(deleteId));
      } else if (modalConfig.actionType === "disable" && disableId) {
        await dispatch(updateAdvertisement({ id: disableId, data: { status: 0 } }));     
      }else if (modalConfig.actionType === "enable"){
        await dispatch(updateAdvertisement({ id: disableId, data: { status: 1 } }));
      }
    } catch (error) {
      console.error("Action failed:", error);
    }finally{
      setRefereshData((prev) => !prev);
      setDisableId(null);
    }
    closeModal();
  };


  const actionItems = (record) =>  [
    {
      key: "edit",
      label: (
        <>
          <EditSvg style={{ marginRight: 8, color: "red" }} />
          Edit Details
        </>
      ),
      // onClick: (record) => navigate("add-category"),
      onClick: (record) => navigate("add-advertisement", { state: { editData: record } }),
 
    },
    {
      key: "disable",
      label: (
        <>
          <DisableSvg style={{ marginRight: 8, color: "red" }} />
          {record.status === 1 ?   "Disable": "Enable"}
        </>
      ),
      // onClick: () => showModal("disable"),
      onClick: (record) => handleDisableClick(record.id, record?.status),
    },
    {
      key: "delete",
      label: (
        <>
          <DeleteSvg style={{ marginRight: 8, color: "red" }} />
          Delete Advertisement
        </>
      ),
      onClick: (record) => handleDeleteClick(record.id), 
    },
  ];
  const handleFilterChange = (key, value, reset = false) => {
    setTableParams((prev) => {
      if (reset) {
        return {
          ...prev,
          
          search_key: "all",
          search_value: "",
          status: undefined,
          position: undefined,
        };
      }
      if (key === "status" || key === "position") {
        return {
          ...prev,
         
          [key]: value,
          search_key: "all",
          search_value: "",
        };
      }
      return {
        ...prev,
        
        search_key: key,
        search_value: value,
        status: undefined,
        position: undefined,
      };
    });
  };
  return (
    <div>
      <div className="addBx">
        <div className="filterBx">
          <Space>
            <CommonFilter
              columns={columns}
              onFilterChange={handleFilterChange}
              searchValue={tableParams.search_value}
            />
          </Space>
        </div>
        <Button
          type="primary"
          icon={<AddSvg />}
          onClick={() => navigate("add-advertisement")}
        >
          Add Advertisement
        </Button>
      </div>
      <div className="tableHeading">List of Advertisement Added</div>
      <ReusableTable
        columns={columns}
        dataSource={listAds ?? []}
        loading={listAdsLoading}
        paginationConfig={paginationConfig}
        onChange={handleTableChange} // Ensure this updates page & size
        actionItems={(record) => actionItems(record)}  
      />
      <ConfirmModal
        titlePrefix="Advertisement"
        messagePrefix="Advertisement"
        open={modalConfig.open}
        onClose={closeModal}
        onConfirm={handleConfirm}
        actionType={modalConfig.actionType}
      />
    </div>
  );
};

export default Advertising;

